
import Component from 'vue-class-component'
import Vue from 'vue'
import {State} from 'vuex-class'
import {Prop} from 'vue-property-decorator'

import ActionMenu from '../Atomic/ActionMenu.vue'
import BlueButton from '../Atomic/BlueButton.vue'
import GreenButton from '../Atomic/GreenButton.vue'
import RedButton from '../Atomic/RedButton.vue'
import CardTitle from '@/components/Atomic/CardTitle.vue'
import ProgressLinear from '../Atomic/ProgressLinear.vue'
import ConfirmationDialog from '@/components/Atomic/ConfirmationDialog.vue'

import CreateOrganisation from './CreateOrganisation.vue'
import EditOrganisation from './EditOrganisation.vue'
import {Organisation} from '../../models/organisation'
import {OrganisationJobTitle} from '../../models/organisationJobTitle'
import GridHeader from '../../models/gridHeader'

import ExtrasService from '../../services/ExtrasService'
import OrganisationsService from '../../services/OrganisationsService'

import {INotificationService} from '../../services/NotificationService'
import ErrorHandlerService from '@/services/ErrorHandlerService'
import {sortStringValues} from '@/utils/utils'
import CreateJobTitles from '@/components/Extras/CreateJobTitles.vue'
import UpdateJobTitles from '@/components/Extras/UpdateJobTitles.vue'

@Component({
  components: {
    UpdateJobTitles,
    CreateJobTitles,
    ActionMenu,
    BlueButton,
    GreenButton,
    RedButton,
    CardTitle,
    CreateOrganisation,
    ConfirmationDialog,
    EditOrganisation,
    ProgressLinear,
  },
})
export default class ManageOrganisations extends Vue {
  @State('user') public user!: any
  @Prop(Function) public readonly onClose!: () => void
  private dialog: boolean = false
  private organisationHeaders: GridHeader[] = []
  private jobTitleHeaders: GridHeader[] = []
  private jobTitles: OrganisationJobTitle[] = []
  private jobTitlesValidated: OrganisationJobTitle[] = []
  private jobTitlesToValidate: OrganisationJobTitle[] = []
  private organisations: Organisation[] = []
  private organisationsToValidate: Organisation[] = []
  private licencesChoices: string[] = ['eo-0', 'eo-3', 'eo-4', 'eo-5']
  private isLoading: boolean = false
  private isPending: boolean = false
  private isPendingSchoolAccess: boolean = false
  private tab: any = null
  private errorHandlerService: ErrorHandlerService
  private $notificationService!: INotificationService

  public show() {
    this.errorHandlerService = new ErrorHandlerService()
    this.createHeaders()
    this.fetchOrganisations()
    this.fetchJobTitles()
    this.dialog = true
  }

  private mounted() {
  }

  private formatOrgForTable(organisation: Organisation[]) {
    let formattedOrg = ''
    organisation.map((org) => {
      for (const prop of ['authority', 'department', 'entity', 'unit']) {

        if (org[prop] !== null) {
          if (prop === 'authority') {
            formattedOrg += '[ ' + org[prop]
          } else {
            formattedOrg += ', ' + org[prop]
          }
        }
      }
      formattedOrg += ' ] '
    })
    return formattedOrg
  }

  private async fetchJobTitles() {
    this.isPending = true
    this.jobTitles = []
    this.jobTitlesValidated = []
    this.jobTitlesToValidate = []
    try {
      this.jobTitles = await OrganisationsService.fetchJobTitles()
      this.jobTitles.sort((a, b) => (a.title > b.title) ? 1 : -1)
      this.parseJobTitleList()
    } catch (error: any) {
      this.errorHandlerService.handle(this, error.response.data.code, true)
    }
    this.isPending = false
  }

  private parseJobTitleList() {
    this.jobTitles.map((jobTitle) => {
      if (!jobTitle.is_validated) {
        this.jobTitlesToValidate.push(jobTitle)
      } else {
        this.jobTitlesValidated.push(jobTitle)
      }
    })
  }

  private async fetchOrganisations() {
    this.isPending = true
    this.organisations = []
    this.organisationsToValidate = []
    try {
      const organisations: Organisation[] = await OrganisationsService.get()
      organisations.forEach((org) => {
        if (org.is_validated === true) {
          this.organisations.push(org)
        } else if (org.is_validated === false) {
          this.organisationsToValidate.push(org)
        }
      })

    } catch (error: any) {
      this.errorHandlerService.handle(this, error.response.data.code, true)
    }
    this.isPending = false
  }

  private createHeaders() {
    this.createOrganisationTableHeaders()
    this.createJobTitleTableHeaders()
  }

  private createOrganisationTableHeaders() {
    this.organisationHeaders = []
    this.organisationHeaders.push(new GridHeader(this.$t('EXTRAS.Authority').toString(), 'authority', 'left', true, 100))
    this.organisationHeaders.push(new GridHeader(this.$t('EXTRAS.Department').toString(), 'department', 'left', true, 100))
    this.organisationHeaders.push(new GridHeader(this.$t('EXTRAS.Entity').toString(), 'entity', 'left', true, 100))
    this.organisationHeaders.push(new GridHeader(this.$t('EXTRAS.Unit').toString(), 'unit', 'left', true, 100))
    this.organisationHeaders.push(new GridHeader(this.$t('License').toString(), 'licence', 'left', true, 100))
    if (this.user.isStaff){
      this.organisationHeaders.push(new GridHeader(this.$t('EXTRAS.SchoolAccess').toString(), 'can_set_school', 'left', true, 180))
    }
    this.organisationHeaders.push(new GridHeader(this.$t('Actions').toString(), 'actions', 'center fixed', true, 100, 'fixed'))
  }

  private createJobTitleTableHeaders() {
    this.jobTitleHeaders = []
    this.jobTitleHeaders.push(new GridHeader(this.$t('EXTRAS.JobTitle').toString(), 'title', 'left', true, 400))
    if (this.user.isStaff === true) {
      this.jobTitleHeaders.push(new GridHeader(this.$t('EXTRAS.JobTitleForGuest').toString(), 'for_guest', 'left', true, 50))
      this.jobTitleHeaders.push(new GridHeader(this.$t('EXTRAS.JobTitleInOrg').toString(), 'organisation', 'center', true, 10))
      this.jobTitleHeaders.push(new GridHeader(this.$t('Actions').toString(), 'actions', 'center fixed', true, 30, 'fixed'))
    }
  }

  private async syncJobTitleWithRepository(id: number, title: string, for_guest: boolean) {
    try {
      this.isPending = true
      await OrganisationsService.updateJobTitle(id, title, for_guest, true)
      this.$notificationService.success(this.$t('EXTRAS.JobTitleValidated').toString())
      await this.fetchJobTitles()
    } catch (error: any) {
      this.errorHandlerService.handle(this, error.response.data.code, true)
    }
    this.isPending = false
  }

  private async syncOrgWithRepository(organisationID: number, licence) {
    try {
      await OrganisationsService.validateOrganisation(organisationID, licence)
      this.$notificationService.success(this.$t('EXTRAS.OrganisationValidated').toString())
    } catch (error: any) {
      this.errorHandlerService.handle(this, error.response.data.code, true)
    }
    await this.fetchOrganisations()
  }

  private async deleteJobTitle(jobTitleID: number) {
    this.isPending = true
    try {
      await OrganisationsService.deleteJobTitle(jobTitleID)
      this.$notificationService.success(this.$t('EXTRAS.JobTitleDeleted').toString())
      await this.fetchJobTitles()
    } catch (error: any) {
      this.errorHandlerService.handle(this, error.response.data.code, true)
    }
    this.isPending = false
    this.hideJobTitleDeleteDialog()
  }

  private async setUnsetSchoolAccess(organisationId: number, schoolAccess: boolean) {
    try {
      this.isPendingSchoolAccess = true
      await OrganisationsService.setUnsetSchoolAccess(organisationId, schoolAccess)
      this.$notificationService.success(this.$t('EXTRAS.UnsetSetSchoolAccessDone').toString())
      await this.fetchOrganisations()
    } catch (error: any){
      this.errorHandlerService.handle(this, error.response.data.code, true)
    } finally {
      this.isPendingSchoolAccess = false
    }
  }

  private async deleteOrg(organisationID: number) {
    try {
      this.isPending = true
      await OrganisationsService.delete(organisationID)
      this.$notificationService.success(this.$t('EXTRAS.OrganisationDeleted').toString())
      await this.fetchOrganisations()
    } catch (error: any) {
      this.errorHandlerService.handle(this, error.response.data.code, true)
    } finally {
      this.isPending = false
      this.hideDeleteDialog()
    }
  }

  private hideDeleteDialog() {
    // (this.$refs as any).confirmDeleteDialog.cancel()
  }

  private hideJobTitleDeleteDialog() {
    // (this.$refs as any).confirmJobTitleDeleteDialog.cancel()
  }

  private async handleJobTitleDialogClose() {
    try {
      this.isPending = true
      await this.fetchJobTitles()
    } catch (error: any) {
      this.errorHandlerService.handle(this, error.response.data.code, true)
    }
    this.isPending = false
  }

  private async handleDialogClose() {
    await this.fetchOrganisations()
    await this.fetchJobTitles()
  }
}
